import CardWrapper from "ds/components/Card/components/Wrapper";
import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import TooltipInfo from "ds/components/TooltipInfo";

import UsageWorkersSeverityIcon from "./SeverityIcon";
import { WorkerUsageMetricCard } from "./types";
import styles from "./styles.module.css";

const UsageWorkersMetricCard = ({
  label,
  value,
  caption,
  severity,
  severityTooltip,
  infoTooltip,
}: WorkerUsageMetricCard) => (
  <CardWrapper className={styles.card} padding="large" gap="medium" zeroMinWidth>
    <Box direction="row" align="center" justify="between" gap="small" fullWidth>
      <Box direction="row" align="center" gap="small" zeroMinWidth>
        <Typography variant="p-t7" tag="span" color="primary">
          {label}
        </Typography>
        {severity && severityTooltip && (
          <UsageWorkersSeverityIcon severity={severity} tooltip={severityTooltip} />
        )}
      </Box>
      {infoTooltip && <TooltipInfo widthMode="maxWidthSm">{infoTooltip}</TooltipInfo>}
    </Box>

    <Typography variant="p-t2" tag="span" color="primary">
      {value}
    </Typography>
    <Typography variant="p-body3" tag="span" color="secondary">
      {caption}
    </Typography>
  </CardWrapper>
);

export default UsageWorkersMetricCard;
